import React from 'react';
import { ErrorBoundary } from '../../../components/error-boundary';
import { MotionModal } from '../../../components/motion-modal/motion-modal';
import { ImageAspectRatioType } from '../../../interfaces';
import { getAggregatedTitleImage } from '../../../queries/ats/common';
import { VodSource } from '../../../queries/ats/titles/types/sources';
import { FocusedAsset } from '../use-focused-asset';
import { PurchaseProductModalContent } from './purchase-product-modal-content';
import css from './purchase-product-modal.module.scss';

export interface PurchaseProductProps {
  asset: FocusedAsset;
  source: VodSource;
  isOpen: boolean;
  onClose: () => void;
}

export function PurchaseProductModal({ asset, source, isOpen, onClose }: PurchaseProductProps) {
  const image = getAggregatedTitleImage(asset.masterId, ImageAspectRatioType.WIDE, 200);

  return (
    <MotionModal classNames={{ content: css.modal }} isOpen={isOpen} onRequestClose={() => onClose()}>
      <MotionModal.Header image={image} />
      <MotionModal.CloseButton onClick={() => onClose()} />

      <ErrorBoundary fallback={(props) => <p>{props.error.message}</p>}>
        <PurchaseProductModalContent asset={asset} source={source} />
      </ErrorBoundary>
    </MotionModal>
  );
}
